module.exports = __webpack_public_path__ + "static/img/bg3.f8b70501.jpg";